import { useEffect, useState } from 'react';
import { graphql, useFragment } from 'react-relay';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';

import { estimatedValueFurnitureTestHelpers_item$key } from './__generated__/estimatedValueFurnitureTestHelpers_item.graphql';

const ESTIMATED_VALUE_FURNITURE_TEST_NAME = 'EstimatedValueFurniture_Nov2024';

const itemFragment = graphql`
    fragment estimatedValueFurnitureTestHelpers_item on Item {
        isFurniture
    }
`;

export const useShowEstimatedValueFurnitureTestVariant = ({
    item: itemRef,
}: {
    item: estimatedValueFurnitureTestHelpers_item$key;
}): boolean => {
    const item = useFragment(itemFragment, itemRef);
    const [isVariant, setIsVariant] = useState(false);

    useEffect(() => {
        const isEstimatedValueVariant =
            item?.isFurniture &&
            getAbTestV2(ESTIMATED_VALUE_FURNITURE_TEST_NAME)?.variant === 'variant';

        setIsVariant(!!isEstimatedValueVariant);
    }, [item]);

    return isVariant;
};

export const trackEstimatedValueFurnitureTest = (): void => {
    trackAbTestV2Variant(ESTIMATED_VALUE_FURNITURE_TEST_NAME);
};
